// extracted by mini-css-extract-plugin
module.exports = {"faq":"FaqScreen_faq__V7L1z","contact":"FaqScreen_contact__qYpuF","btn":"FaqScreen_btn__3Tjci","subtitle":"FaqScreen_subtitle__1Xsi-"};